import { useEffect, useState } from 'react';
import { getDeviceTypeAsync, DeviceType } from 'expo-device';

export const useDeviceType = () => {
	const [deviceType, setDeviceType] = useState<DeviceTypeState>('loading');
	useEffect(() => {
		const determineDeviceType = async () => {
			const type = await getDeviceTypeAsync();
			setDeviceType(type);
		};

		void determineDeviceType();
	}, []);

	return deviceType;
};

type DeviceTypeState = 'loading' | DeviceType;
